import React, { Component } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field as FormikField } from "formik";
import { normalizeDocumentForPayload } from "utils/formatting/document";
import {
  applyCpfCnpjInputMask,
  getCpfCnpjLoginFieldError,
} from "utils/validation/cpfCnpjLoginField";
import { Modal, Form as BootstrapForm } from "react-bootstrap";
import { toast } from "react-toastify";

import Field from "../../field";
import StyledButton from "../../button";
import ModalFindYourCode from "./findYourCode";
import {
  toggleStep,
  getUserId,
  handleUserInfo
} from "../../../../store/actions/multiplos-actions";
import api from "../../../../services/api";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  FieldsContainer,
  Fields,
  FindYourCode,
  FindYourCodeText,
  FindYourCodeIcon,
  ButtonContainer
} from "../styles";

class Document extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModalCode: false
    };
  }

  async componentDidMount() {
    this.requestGetUserId();
  }

  requestGetUserId = () => {
    const loginEmail = localStorage.getItem("@UltragazEmpresarial:loginEmail");
    const header = {
      "Content-Type": "application/json"
    };
    const parameters = {
      method: "GET",
      headers: header
    };
    api
      .get(`industrial/customer/v1/users?login=${loginEmail}`, parameters)
      .then(res => {
        const response = res.data;
        if (response.length >= 1) {
          const userId = response[0].userId;
          this.props.dispatch(getUserId(userId));
        } else {
          toast.error(
            "Não foi possível encontrar o userId, entre em contato com a Ultragaz ou tente novamente mais tarde!"
          );
        }
      })
      .catch(err => {
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  };

  requestRegisterContract = values => {
    this.setState({ loading: true });
    const { userId } = this.props;
    const access_token = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    let { user, document } = values;
    document = normalizeDocumentForPayload(document);
    this.props.dispatch(handleUserInfo(user, document));
    const header = {
      "Content-Type": "application/json",
      access_token
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      customerCode: user,
      document: document
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/customers`,
        body,
        parameters
      )
      .then(res => {
        if (res.status === 201) {
          this.props.dispatch(toggleStep(5));
        }
      })
      .catch(err => {
        if (err.response.data.code === "422.014") {
          this.props.dispatch(toggleStep(2));
        } else {
          this.setState({ loading: false });
          const message = err.response.data.message;
          if (message) {
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  };

  validationSchema = () =>
    Yup.object().shape({
      user: Yup.number().required("Insira um código")
    });

  validateUser = value => {
    let error;
    if (!value) {
      error = "É obrigatório preencher seus dados!";
    }
    return error;
  };

  validateDocument = value => getCpfCnpjLoginFieldError(value);

  handleDocument = (e, handleChange) => {
    const event = e;
    applyCpfCnpjInputMask(event);
    handleChange(event);
  };

  handleUser = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");
    if (numbers.length === 30) {
      event.target.value = numbers;
    }
    handleChange(event);
  };

  handleShowModal = () => {
    this.setState({
      showModalCode: true
    });
  };

  render() {
    const { close, back } = this.props;
    return (
      <Formik
        initialValues={{
          user: "",
          document: ""
        }}
        onSubmit={values => {
          this.requestRegisterContract(values);
        }}
        validationSchema={this.validationSchema}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <Container>
            <Header>
              <Left>
                {back ? (
                  <BackButton
                    title="Fechar"
                    className="mdi mdi-arrow-left"
                    onClick={() => this.props.dispatch(toggleStep(1))}
                  />
                ) : null}
                <Title>Vincular Novo Contrato</Title>
              </Left>
              <CloseIcon
                title="Fechar"
                className="mdi mdi-close"
                onClick={close}
              />
            </Header>
            <Content>
              Confirme os dados abaixo para verificarmos seu vinculo com o novo
              contrato:
            </Content>
            <FieldsContainer>
              <Fields>
                <Form>
                  <BootstrapForm.Group controlId="user">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <Field
                            {...field}
                            type="text"
                            label="Código do Cliente"
                            ariaLabel="Código do Cliente"
                            ariaRequired
                            errorCondition={errors.user && touched.user}
                            errorMessage={errors.user}
                            title="Código do Cliente"
                            onBlur={handleBlur}
                            maxLength={30}
                            placeholder="Seu código"
                            value={values.user}
                            onChange={e => {
                              this.handleUser(e, handleChange);
                            }}
                          />
                        );
                      }}
                      validate={this.validateUser}
                      name="user"
                    />
                  </BootstrapForm.Group>
                  <FindYourCode onClick={() => this.handleShowModal()}>
                    <FindYourCodeText>Encontre seu Código</FindYourCodeText>
                    <FindYourCodeIcon className="mdi mdi-help-circle" />
                  </FindYourCode>
                  <BootstrapForm.Group controlId="document">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <Field
                            {...field}
                            type="text"
                            label="Seu CNPJ"
                            ariaLabel="Seu CNPJ"
                            ariaRequired
                            errorCondition={errors.document && touched.document}
                            errorMessage={errors.document}
                            title="Seu CNPJ"
                            onBlur={handleBlur}
                            placeholder="Seu CNPJ"
                            value={values.document}
                            onChange={e => {
                              this.handleDocument(e, handleChange);
                            }}
                          />
                        );
                      }}
                      validate={this.validateDocument}
                      name="document"
                    />
                  </BootstrapForm.Group>
                  <ButtonContainer>
                    <StyledButton
                      className="mt-4"
                      type="submit"
                      icon="account-plus"
                      text="Confirmar"
                      loading={this.state.loading}
                      color="#F0B01B"
                    />
                  </ButtonContainer>
                </Form>
              </Fields>
            </FieldsContainer>
            <Modal
              show={this.state.showModalCode}
              onHide={() =>
                this.setState({
                  showModalCode: false
                })
              }
              size="lg"
              centered
              animation={false}
            >
              <ModalFindYourCode />
            </Modal>
          </Container>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  userId: state.multiplosReducer.userId
});

export default connect(mapStateToProps)(Document);
